<div class="setting-section">
  <app-customer-mngt-detail [countries]="countries" (customerSaved)="onCustomerSaved($event)"></app-customer-mngt-detail>

  <div class="fc-mngt-toolbar">
    <h2 class="fc-mngt-title">Customers</h2>
    <div class="fc-mngt-search">
      <span class="material-icons fc-mngt-search-icon">search</span>
      <input class="fc-mngt-search-input" type="text" placeholder="Filter customers…" (keyup)="doFilter($any($event.target).value)" />
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" class="customersTable" matSort>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
      <td mat-cell *matCellDef="let element">{{ element.address }}</td>
    </ng-container>
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
      <td mat-cell *matCellDef="let element">{{ element.city }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
      <td mat-cell *matCellDef="let element">{{ getCountryById(element.country)?.name }}</td>
    </ng-container>
    <ng-container matColumnDef="timeZone">
      <th mat-header-cell *matHeaderCellDef>Time Zone</th>
      <td mat-cell *matCellDef="let element">{{ element.timeZone }}</td>
    </ng-container>
    <ng-container matColumnDef="hasImage">
      <th mat-header-cell *matHeaderCellDef>Image</th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.hasImage" class="fc-action-btn" (click)="viewImgDialog(element.id)">View</button>
      </td>
    </ng-container>
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="actionButtonCol">
        <button class="fc-action-btn" (click)="edit(element)">Edit</button>
        <button class="fc-action-btn fc-action-btn--danger" (click)="deleteConfirmDialog(element)">Delete</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell fc-no-data" colspan="8">No customers found</td>
    </tr>
  </table>
</div>
